import React, { useState } from "react";
import { getAPI, postAPI } from "../../../helpers/httpHelper";
import { cognitoUserToken } from "../../../helpers/userHelper";
import { API_ADMIN_LIO_INSPECTOR_TRANSELEC, API_ADMIN_GERENCIA, URL_SUPPORT, ROW_COUNT } from "../../../helpers/variableHelper";
import { usePromiseEffect } from "../../../helpers/promiseEffect";
import AdminLista from "../AdminLista";
import IVicePresidencia from "../../../entities/IVicePresidencia";
import { cParamsActiveOrderTitle } from "../../../helpers/paramsHelper";
interface ILIOInspectorTranselecProps {
  cbVicePresidencia?: Array<IVicePresidencia>;
  is_test?: boolean;
}

const LIOInspectorTranselec = ({ cbVicePresidencia, is_test }: ILIOInspectorTranselecProps) => {
  const userInfo = cognitoUserToken();
  const [token, setToken] = useState("");
  const [listItems, setListItems] = useState<Array<any>>([]);
  const [comboGrc, setComboGrc] = useState<Array<IVicePresidencia>>(cbVicePresidencia || []);
  const [isLoading, setIsLoading] = useState(false);
  const [pages, setPages] = useState(0);
  const [page, setPage] = useState(1);
  const [pageSize, setPageSize] = useState(ROW_COUNT);

  usePromiseEffect(async () => {
    setIsLoading(true);
    let token = await userInfo;
    setToken(token);
    let params = {
      PAGINA: 1,
      PAGINADO: pageSize,
      ORDENADOPOR: "ID",
      ORIENTACION: "DESC",
      TITULO: null,
      USUARIO: null,
      ID_GERENCIA_SUBGERENCIA: null,
      ACTIVO: null,
    };
    let result = is_test
      ? { data: [], pages: 10 }
      : (await getAPI(`${URL_SUPPORT}${API_ADMIN_LIO_INSPECTOR_TRANSELEC}/getall`, { Authorization: `Bearer ${token}` }, params)).result;
    let list = result.data;
    setListItems(list);
    let pages = result.pages;
    setPages(pages);

    const combo = is_test
      ? []
      : (await getAPI(`${URL_SUPPORT}${API_ADMIN_GERENCIA}/getall`, { Authorization: `Bearer ${token}` }, cParamsActiveOrderTitle)).result.data;
    setComboGrc(combo);
    setIsLoading(false);
  }, [token]);

  const paging = (page: any) => {
    setPage(page);
    let params = { PAGINA: page };
    filter(params, true);
  };
  const filter = (filter: any, havePage: boolean = false, size = pageSize) => {
    if (!filter) {
      filter = {};
      filter.PAGINA = 1;
    }
    filter.PAGINADO = size;
    if (filter.PAGINA === undefined) {
      filter.PAGINA = page ?? 1;
    }
    if (!havePage && filter.PAGINA === undefined) {
      filter.PAGINA = page ?? 1;
    }
    setPage(filter.PAGINA);
    if (filter.ORDENADOPOR === undefined) {
      filter.ORDENADOPOR = "ID";
      filter.ORIENTACION = "DESC";
    }
    getAPI(`${URL_SUPPORT}${API_ADMIN_LIO_INSPECTOR_TRANSELEC}/getall`, { Authorization: `Bearer ${token}` }, filter)
      .then((result) => {
        setIsLoading(false);
        let pages = result.result.pages;
        setPages(pages);
        setListItems(result.result.data);
      })
      .catch((error) => {});
  };
  const edit = (value: any, filters: any) => {
    delete value.TRANSACTION_ID;
    if (value.ID === "") {
      delete value.ID;
    }
    postAPI(`${URL_SUPPORT}${API_ADMIN_LIO_INSPECTOR_TRANSELEC}`, value, { Authorization: `Bearer ${token}` })
      .then((result) => {
        let data = result.result.data;
        console.log(data);
        filter(filters, value?.ID > 0);
      })
      .catch((error) => {
        console.log(error);
      });
  };
  return (
    <>
      {" "}
      <button
        data-testid="btnedit"
        hidden={true}
        onClick={() => {
          edit(
            {
              ID: "",
              ACTIVO: true,
              ID_ACTO: "1",
              ID_TIPO_CAUSA: 1,
              ORDENADOPOR: "",
              ORIENTACION: "",
              PAGINA: 1,
              PAGINADO: 10,
              TIPO_CAUSA: "",
              TITULO: "",
            },
            {}
          );
          filter({});
          filter({ PAGINA: 1 });
          filter({ PAGINA: 1 }, true, 1);
          filter({ PAGINA: undefined }, false);
          paging(2);
        }}></button>
      <AdminLista
        reload={filter}
        items={[
          {
            type: "ID_GERENCIA_SUBGERENCIA",
            value: comboGrc.map((grc) => {
              return { text: grc.TITULO, value: grc.ID };
            }),
          },
        ]}
        callback={edit}
        data={listItems}
        tipo={"LIOInspectorTranselec"}
        filter={filter}
        pagination={{ pages: pages, page: page, paging: paging }}
        title="Inspeccionado por"
        callbackUpdatePageSize={(pageSize: number, filters: Object) => {
          setPageSize(pageSize);
          filter(filters, false, pageSize);
        }}
        isLoading={isLoading}
      />
    </>
  );
};

export default LIOInspectorTranselec;
